<template>
  <v-list-item
    v-if="item"
    @click="open"
  >
    <v-list-item-avatar>
      <v-img
        transition="false"
        :src="$http.defaults.baseURL + '/images/' + item.image"
        :lazy-src="$http.defaults.baseURL + '/images/' + item.lazyImage"
      ></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{item.name}}</v-list-item-title>
      <v-list-item-subtitle><strong>{{item.description}}</strong></v-list-item-subtitle>
      <v-list-item-subtitle>
        <v-rating
          :value="item.service.rating ? item.service.rating : 0"
          color="yellow accent-4"
          dense
          half-increments
          readonly
          size="18"
        ></v-rating>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-list-item-action-text>Sponsored</v-list-item-action-text>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    n: Number
  },

  data () {
    return {
      item: null
    }
  },

  methods: {
    open () {
      axios.post('/api/ads/click', { id: this.item._id })
      this.$emit('open', this.item.service._id)
    }
  },

  async mounted () {
    try {
      const { data } = await axios.post('/api/ads', {
        n: this.n
      })

      if (data) {
        this.item = data
      }
    } catch (e) {
      console.log(e.message)
    }
  }
}
</script>
